import React, { useEffect } from 'react'
import { DatePicker, Form, Typography } from 'antd'
import { useQAAssessmentActionsContext } from 'contexts/QAAssessmentActionsContext'
import { getCssSelectorForLinkId } from 'utils/helpers'
import { QuestionnaireAnswerType } from 'components/Assessments/assessmentType'
import { useQAAssessmentCommentsContext } from 'contexts/QAAssessmentCommentsContext'
import { getCommentQuestionLinkId } from 'components/QA/Assessments/helpers'
import { useAssessmentContext } from 'contexts/AssessmentContext'
import { HalfWidthContainer, ItemWithTextDetailsContainer } from './styles'
import { extractDataFromReference } from './helpers'
import { useValidateAndUpdateValues } from '../PatAssessment/hooks/useValidateAndUpdateFormValues'

export const DateInput = ({ question, data, dataReference }): JSX.Element => {
  const {
    assessmentStatusState: { inQA, inQAEdit }
  } = useAssessmentContext()
  const { createCommentClickHandler, disableHover } = useQAAssessmentActionsContext()
  const validateAndUpdateFormValues = useValidateAndUpdateValues()

  const { sortedComments: comments, focusedCommentId } = useQAAssessmentCommentsContext()
  const focusedComment = comments.find((c) => c.id === focusedCommentId)
  const focusedCommentLinkId = focusedComment ? getCommentQuestionLinkId(focusedComment) : null

  const defaultValue = extractDataFromReference(data, dataReference)

  useEffect(() => {
    validateAndUpdateFormValues({
      type: question.type as QuestionnaireAnswerType,
      linkId: question.linkId,
      text: question.text,
      value: defaultValue
    })
  }, [])

  return (
    <ItemWithTextDetailsContainer
      id={getCssSelectorForLinkId(question.linkId)}
      inQA={inQA && !defaultValue}
      inQAEdit={inQAEdit && !defaultValue}
      disableHover={disableHover}
      isFocused={focusedCommentLinkId === question.linkId}
      onClick={() => question.linkId && !defaultValue && createCommentClickHandler(question.linkId)}
    >
      <HalfWidthContainer>
        <Typography.Title level={5}>{question.text}</Typography.Title>
      </HalfWidthContainer>
      <HalfWidthContainer>
        <Form.Item
          name={question.linkId}
          initialValue={defaultValue}
          rules={[{ required: question.required, message: 'Please select an option' }]}
        >
          <DatePicker
            disabled={question.readOnly || undefined}
            style={{ width: '100%' }}
            format="MM/DD/YYYY"
          />
        </Form.Item>
      </HalfWidthContainer>
    </ItemWithTextDetailsContainer>
  )
}
